import {AppDispatch} from "../../../../store/types/AppDispatch";
import {setAllowAuthenticatedRoutes} from "../../../auth/state/auth_slice";
import {UserAmplitudePhoneVerifiedLocation} from "../../../tracking/amplitude/user_amplitude_tracker";
import {handleCloseRegistrationPhoneNumberModal, requestPhoneVerification} from "../../state/user_phone_verification_slice";
import {createRegistrationOnboardingPendingAction} from "../types/phone_verification_types";

export const requestRegistrationOnboardingPhoneVerification = (dispatch: AppDispatch, location: UserAmplitudePhoneVerifiedLocation) => {
    dispatch(
        requestPhoneVerification({
            pendingAction: createRegistrationOnboardingPendingAction(location),
            awaitCompletion: true
        })
    );
};

export const completeRegistrationOnboarding = (dispatch: AppDispatch, onAfterRegister: () => void) => {
    dispatch(handleCloseRegistrationPhoneNumberModal());
    dispatch(setAllowAuthenticatedRoutes(true));
    onAfterRegister();
};
import {AppDispatch} from "../../../../store/types/AppDispatch";
import {setAllowAuthenticatedRoutes} from "../../../auth/state/auth_slice";
import {UserAmplitudePhoneVerifiedLocation} from "../../../tracking/amplitude/user_amplitude_tracker";
import {handleCloseRegistrationPhoneNumberModal, requestPhoneVerification} from "../../state/user_phone_verification_slice";
import {createRegistrationOnboardingPendingAction} from "../types/phone_verification_types";

export const requestRegistrationOnboardingPhoneVerification = (dispatch: AppDispatch, location: UserAmplitudePhoneVerifiedLocation) => {
    dispatch(
        requestPhoneVerification({
            pendingAction: createRegistrationOnboardingPendingAction(location),
            awaitCompletion: true
        })
    );
};

export const completeRegistrationOnboarding = (dispatch: AppDispatch, onAfterRegister: () => void) => {
    dispatch(handleCloseRegistrationPhoneNumberModal());
    dispatch(setAllowAuthenticatedRoutes(true));
    onAfterRegister();
};
